import React from "react";
import { default as ReactSelect } from "react-select";
import { components } from "react-select";
import "./style.scss";

const Option = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <div className="d-flex">
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />
          <label className="label-style">{props.label}</label>
        </div>
      </components.Option>
    </div>
  );
};

const defaultLabel = (props) => (
  <div>
    <components.Option {...props}>
      <div className="d-flex">
        <label>{props.label}</label>
      </div>
    </components.Option>
  </div>
);

const MultiSelect = ({
  isSearachable = false,
  handleChange,
  options,
  value,
  clearable,
  styles = {},
  onBlur,
  borderStyle,
  isLoading,
  loadingMessage,
  noOptionsMessage,
  isMulti = true,
  width,
  isMarkable = true,
  handleSelect,
  closeMenuOnSelect = false,
  displayValue = false,
}) => {
  const customStyles = {
    control: (base) => ({
      ...base,
      border: borderStyle || "1px solid #102E88",
      width: width || "100%",
    }),
    placeholder: (base) => ({ ...base, fontSize: "12px" }),
  };

  const componentStyles = { ...customStyles, ...styles };

  return (
    <span
      className="d-inline-block"
      data-toggle="popover"
      data-trigger="focus"
      data-content="Select options"
    >
      <ReactSelect
        options={options}
        isMulti={isMulti}
        isLoading={isLoading}
        loadingMessage={() => loadingMessage}
        isSearachable={isSearachable}
        hideSelectedOptions={false}
        components={{
          Option: isMarkable ? Option : defaultLabel,
        }}
        // isClearable
        onChange={handleChange}
        // onSelect={handleSelect}
        value={value}
        controlShouldRenderValue={displayValue}
        // isClearable={clearable}
        styles={componentStyles}
        onBlur={onBlur}
        closeMenuOnSelect={closeMenuOnSelect}
        noOptionsMessage={() => noOptionsMessage}
      />
    </span>
  );
};

export default MultiSelect;
